// extracted by mini-css-extract-plugin
module.exports = {"section":"F_section__3t16x"};